enum TransferOptions {
  MOVE = 'MOVE',
  COPY = 'COPY',
  NONE = 'NONE',
}

export default TransferOptions;
